import { RowsPlusTopIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const InsertPrev = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <RowsPlusTopIcon {...rest} size={Sizes[size]} color={fill} />;
};

InsertPrev.displayName = 'InsertPrev';
